import { K0 } from "@/config/const";

export const o_pt_E = (data: any) => {
  const legend: any = [
    "露点线（汽化率=1）",
    "泡点线（汽化率=0）",
    "汽化率0.2压力线",
    "汽化率0.5压力线",
    "汽化率0.8压力线",
  ];
  const series: any = [];
  const T_dew: any = []; //露点温度
  const T_bub: any = []; //泡点温度
  const P02: any = []; //泡点温度
  const P05: any = []; //泡点温度
  const P08: any = []; //泡点温度

  const xdata = [...data[0]];

  xdata.map((item: any, index: any) => {
    // T_dew.push( data[1][index]);
    // T_bub.push(data[2][index]);
    // P02.push(data[3][0][index]);
    // P05.push(data[3][1][index]);
    // P08.push(data[3][2][index]);
    T_dew.push(data[1][index]);
    T_bub.push(data[2][index]);
    P02.push(data[3][0][index]);
    P05.push(data[3][1][index]);
    P08.push(data[3][2][index]);
    // T_dew.push(Math.log10(data[1][index]));
    // T_bub.push(Math.log10(data[2][index]));
    // P02.push(Math.log10(data[3][0][index]));
    // P05.push(Math.log10(data[3][1][index]));
    // P08.push(Math.log10(data[3][2][index]));
  });

  const d: any = [T_dew, T_bub, P02, P05, P08];
  legend.map((item:any,index:any)=>{
    series.push({
      name: item,
      type: "line",
      symbolSize: 0,
      data: d[index],
    })
  })


  return {
    // title: {
    //   text: "混合物P-T包络线图",
    //   left: "center",
    //   top: "10px",
    //   textStyle: {
    //     fontSize: 20,
    //     fontWeight: "bold",
    //     color: "#000",
    //   },
    // },
    grid:{
      top:45,
      right:180
    },
    tooltip: {
      trigger: "axis",
      // formatter:  (params:any)=>{
      //   return `${params.seriesName}<br/>${params.marker}${params.name}: ${params.value[1]}`;
      // },
    },
    legend: {
      top: "10%",
      right: "0",
      data: legend, 
      orient:'vertical',
      icon: "circle",
    },
    xAxis: {
      type: "category",
      name: "°C",
      splitLine: { show: true },
      // nameLocation: "middle",
      // nameGap: 30,
      nameTextStyle: {
        fontSize: 12,
        // fontWeight: "bold",
        color: "#000",
      },
      data: xdata.map((item:any)=>Number((item-K0).toFixed(2))),
    },
    yAxis: {
      type: "value",
      name: "Pa",
      // nameLocation: "middle",
      // nameGap: 30,
      nameTextStyle: {
        fontSize: 12,
        // fontWeight: "bold",
        color: "#000",
      },
    },
    series
  };
};
